import { styled } from '@mui/material/styles';
import { Button as BaseButton } from 'components/buttons';
import { default as RotatingSelectBase } from 'components/RotatingSelect';

export const Button = styled(BaseButton)(({ theme }) => ({
  marginRight: theme.spacing(2),
  '@media (max-width: 500px)': {
    // margin: 0 auto;
    // width: 100%;
    alignSelf: 'center'
  }
}));

export const ButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  margin: theme.spacing(4, 0, 0, 0),
  whiteSpace: 'nowrap',
  [`& ${Button}`]: {
    maxWidth: '300px',
    flexShrink: 1
  },
  '@media (max-width: 1210px)': {
    [`& ${Button}`]: {
      marginBottom: theme.spacing(2)
    }
  }
}));

export const Container = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '100%'
}));

export const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  margin: theme.spacing(0, 0, 2, 0),
  '@media (max-width: 500px)': {
    flexDirection: 'column'
  }
}));

export const InformationContainer = styled('div')(({ theme, widget }) => ({
  '& + &': {
    '&::before': {
      borderTop: `1px solid ${theme.color.grey[500]}`,
      content: '""',
      display: 'block',
      left: 0,
      marginRight: widget ? theme.spacing(5) : '0px',
      marginBottom: theme.spacing(2)
    }
  },
  '@media (max-width: 1014px)': {
    '& + &': {
      '&::before': {
        marginRight: '0px'
      }
    }
  },
  '@media (max-width: 500px)': {
    '& + &': {
      '&::before': {
        borderTop: 'none'
      }
    }
  }
}));

export const LoaderContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column'
}));

export const RotatingSelect = styled(RotatingSelectBase)(() => ({
  display: 'flex',
  flex: '1 1 100%',
  background: 'red'
}));
